import {useState} from 'react'
import StakeholderModal from './StakeholderModal'
import {useNavigate} from 'react-router-dom'
import {ReportDetail} from 'models/Reports'
interface Props {
 title: string
 description: string
 image: string | null
 details: ReportDetail[]
 reportKey: string
}

export default function ReportCard({
 title,
 reportKey,
 description,
 image,
 details,
}: Props) {
 const [open, setOpen] = useState(false)
 const navigate = useNavigate()
 const handleCardClick = () => {
  if (details?.length === 1) {
   const subType =
    details[0]?.sub_type ||
    details[0]?.sub_type_display_name

   navigate(
    `/quick-links/reports?report_key=${reportKey}&sub_type=${subType}&page=1&page_size=1000`,
    {
     state: {
      details: details,
      selectedStakeholder: details[0],
     },
    }
   )
  } else {
   setOpen(true)
  }
 }
 return (
  <>
   <div
    className='rounded-[12px] border border-[#E4E6EF] overflow-hidden bg-white hover:shadow-md transition cursor-pointer'
    onClick={handleCardClick}
   >
    <div className='h-[120px] w-full'>
     {image ? (
      <img
       src={image}
       alt={title}
       className='w-full h-full object-cover'
      />
     ) : (
      <div className='h-full w-full bg-[#D7E7F5] flex items-center justify-center'>
       <img
        src='/media/logos/farm_rise_one_logo.png'
        alt='Farm Rise One'
        className='w-[100px] h-[100px]'
       />
      </div>
     )}
    </div>

    <div className='p-5'>
     <h5 className='text-[16px] font-semibold mb-[6px]'>
      {title}
     </h5>

     <p className='text-[13px] text-[#7E8299] leading-[1.4] line-clamp-2'>
      {description || ''}
     </p>
    </div>
   </div>

   <StakeholderModal
    open={open}
    onClose={() => setOpen(false)}
    details={details}
    reportKey={reportKey}
   />
  </>
 )
}
